import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  apartmentHeaderInfo: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > div:not(:last-child)': {
      borderRight: '2px solid',
    },
    '& > div': {
      marginBottom: '5px',
      overflow: 'hidden',
      overflowWrap: 'break-word',
    },
  },
  placingInfo: {
    fontSize: '12px',
    padding: '0px 5px',
    fontWeight: 'bold',
  },
}));
